import Cookies from 'js-cookie';
import { parseHost } from 'ufo';
import { ALLOWED_EXTERNAL_COOKIE_DOMAIN_PATTERN } from '@/utilities/Constants';

export const COOKIE_API_ACCESS_TOKEN = import.meta.env.VITE_API_ACCESS_TOKEN_COOKIE;

export const COOKIE_API_REFRESH_TOKEN = import.meta.env.VITE_API_REFRESH_TOKEN_COOKIE;

export const COOKIE_USER_INFO = import.meta.env.VITE_USER_INFO_COOKIE;

const getCookieDomain = (): string => {
	const { hostname } = parseHost(window.location.host);
	const [topLevelDomain, secondLevelDomain] = hostname.split('.').reverse();

	const isValidExternalCookieDomainPattern = ALLOWED_EXTERNAL_COOKIE_DOMAIN_PATTERN.some((pattern) => hostname.includes(pattern));

	if (isValidExternalCookieDomainPattern) {
		return hostname;
	}

	return `${secondLevelDomain}.${topLevelDomain}`;
};

export const setCookie = (name: string, value: string, options: Cookies.CookieAttributes = {}): void => {
	Cookies.set(name, value, { domain: getCookieDomain(), expires: 90, ...options });
};

export const removeCookie = (name: string, options: Cookies.CookieAttributes = {}): void => {
	Cookies.remove(name, { domain: getCookieDomain(), ...options });
	Cookies.remove(name, { ...options });
};
